import React, { useRef, useEffect } from 'react';
import close from '../../assets/icons/close-icon.svg';

import {
	CloseButton,
	StyledModal,
	ModalContent,
	BackgroundModal,
	HeaderModal,
	TitleModal,
	BodyModal,
	ModalImage,
	ModalDescription,
	ModalButton,
	ModalDetails,
	ModalAssets,
} from './styles';

const Modal = ({ modalInformation, open, setOpen }) => {
	const closeModal = () => {
		setOpen(!open);
	};
	const modal = useRef(null);
	useEffect(() => {
		window.onclick = function (event) {
			if (event.target == modal.current) {
				setOpen(!open);
			}
		};
	});
	return (
		<>
			<StyledModal open={open} ref={modal}>
				<ModalContent>
					<HeaderModal>
						<TitleModal>{modalInformation?.title}</TitleModal>
						<CloseButton src={close} onClick={closeModal}></CloseButton>
					</HeaderModal>
					<BodyModal>
						<ModalImage src={modalInformation.image} />
						<ModalAssets>
							<ModalDescription>{modalInformation.description}</ModalDescription>
							<ModalDetails>{modalInformation.details}</ModalDetails>
						</ModalAssets>
						<ModalButton
							target='blank'
							href={`https://api.whatsapp.com/send?phone=+5491156011120&text=Hola!%20Me%20gustar%C3%ADa%20consultarte%20sobre%20el/la%20${modalInformation.title}`}>
							Solicitar información
						</ModalButton>
					</BodyModal>
				</ModalContent>
			</StyledModal>
		</>
	);
};
export default Modal;
